import { RoutingFlags } from '@constants/routingFlags';

import { CarrierLaneSearchRoute } from './laneSearch';
import { CarrierPlaylists } from './playlists';

const CarrierRoute = {
  path: '/carrier',
  load: () => import('./Carrier'),
  routingFlag: RoutingFlags.V4CarrierSearch,
  protected: true,
};

const CarrierDetailsRoute = {
  path: '/carrier/details/:id',
  load: () => import('./carrierDetails'),
  // featureFlag: featureFlags.v4CarrierDetails,
  protected: true,
};

const NewCarrierDetailsRoute = {
  path: '/carrier/details',
  load: () => import('./carrierDetails'),
  protected: true,
};

const SendCarrierPacketRoute = {
  path: '/carrier/sendcarrierpacket',
  load: () => import('./carrierDetails/carrierPacket'),
  protected: true,
};

export {
  CarrierDetailsRoute,
  CarrierLaneSearchRoute,
  CarrierPlaylists,
  CarrierRoute,
  NewCarrierDetailsRoute,
  SendCarrierPacketRoute,
};

// stop
